import {getBasePath} from '../utils/config';

export const assetsData = {
    fonts: ['IntroBlack', 'Montserrat, Arvo'],
    images: [
        //getBasePath() + "/images/snow-blue.jpg",
        getBasePath() + "/images/sensei-sentinels-of-the-sea-ice.webp",
    ],
};